<template>
  <div class="disclaimer">
    <p>
      <small>Disclamer: Let op! Aan de uitkomst van de berekening kunnen geen rechten worden ontleend. De rekentool is alleen bedoeld als hulpmiddel.</small>
    </p>
  </div>
</template>

<script>
  export default({
  })
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/disclaimer.vue